import { SERVICES } from "@/data/site";
import Reveal from "@/components/Reveal";

const Services = () => (
  <section id="services" className="bg-navy-950 py-16 sm:py-24">
    <div className="container-x">
      <Reveal>
        <p className="mb-3 text-sm font-semibold text-teal-400">الخدمات والمنهجية</p>
        <h2 className="max-w-xl text-2xl font-bold leading-snug sm:text-3xl lg:text-4xl">
          طريقة عمل واضحة، تحوّل الدراسة إلى تقدم ملموس
        </h2>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.07} className="h-full">
            <div
              data-testid={`service-card-${i + 1}`}
              className="flex h-full flex-col rounded-2xl border border-white/8 bg-navy-800/80 p-6 transition duration-300 hover:-translate-y-1 hover:border-teal-500/40"
            >
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-teal-500/12 text-teal-400">
                <s.icon className="h-6 w-6" />
              </div>
              <h3 className="text-lg font-bold">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-soft">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
